<template>
  <div class="title">
    <div class="left" @click="goBack">
      <img src="../../assets/cancel.png" alt />
    </div>
    <div class="right">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'HeadTitle',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    returnPath: {
      type: String,
      default: null
    },
    query: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {
    console.log(this.returnPath, 'returnPath');
  },
  mounted() {},
  methods: {
    goBack() {
      if (this.returnPath) {
        this.$router.push({
          name: this.returnPath,
          query: this.query
        });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  background: rgba(255, 255, 255);
  display: flex;
  height: 44px;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 999;
  .left {
    height: 25px;
    img {
      width: 15px;
      height: 25px;
    }
    margin-right: 12px;
    margin-left: 16px;
  }
  .right {
    height: 18px;
    line-height: 18px;
    font-size: 18px;
    // font-weight: 900;
    color: #333333;
  }
}
</style>
